import { useRef, useState } from "react";
import handleNotify from "../utils/helpers/handleNotify.js";
import { apiFetchCodePhoneNumber } from "../api/methods/verification.js";

/**
 * Время отводимое для подтверждения кода из СМС (в секундах)
 */
export const REMAINING_SECONDS = 180;

const useConfirmPhoneNumber = () => {
  const [smsCode, setSmsCode] = useState("");
  const [remainingSeconds, setRemainingSeconds] = useState(REMAINING_SECONDS);

  const [isSuccessConfirmSmsCode, setIsSuccessConfirmSmsCode] = useState(false);
  const [isDisabledButton, setIsDisabledButton] = useState(true);

  const [isFetchData, setIsFetchData] = useState(false);
  const [hasError, setHasError] = useState(false);

  const timerConfirmPhoneNumber = useRef(null);
  const inputSmsCode = useRef(null);

  /**
   * Получить СМС-код
   *
   * @param {String} phoneNumber
   */
  const getSmsCode = async phoneNumber => {
    try {
      setIsFetchData(true);
      setRemainingSeconds(REMAINING_SECONDS);
      inputSmsCode.current?.classList.remove("input--invalid");

      await apiFetchCodePhoneNumber(phoneNumber);

      startTimer();
    } catch (error) {
      setHasError(true);
      setRemainingSeconds(0);

      if (error?.response?.data?.status_id === 515) {
        handleNotify("error", null, "Вы уже отправили смс");
      } else {
        handleNotify("error", error);
      }
    } finally {
      setIsFetchData(false);
    }
  };

  /**
   * Запустить таймер обратного отсчета (после отправки запроса на СМС-код)
   */
  const startTimer = () => {
    timerConfirmPhoneNumber.current = setInterval(() => {
      setRemainingSeconds(prevState => prevState - 1);
    }, 1000);
  };

  const checkRemainingSeconds = () => {
    if (remainingSeconds <= 0) {
      inputSmsCode.current?.classList.remove("input--invalid");
      setSmsCode("");

      clearInterval(timerConfirmPhoneNumber.current);
    }
  };

  /**
   * Установить значение введенное в поле с кодом
   */
  const changeSmsCode = event => {
    const uniqueCode = event.target.value.replace(/\D+/g, "");
    inputSmsCode.current?.classList.remove("input--invalid");

    if (uniqueCode.length < 4) {
      setIsDisabledButton(true);
    } else {
      setIsDisabledButton(false);
    }

    setSmsCode(uniqueCode);
  };

  return {
    smsCode,
    setSmsCode,
    remainingSeconds,
    setRemainingSeconds,
    isSuccessConfirmSmsCode,
    setIsSuccessConfirmSmsCode,
    isDisabledButton,
    setIsDisabledButton,
    isFetchData,
    hasError,
    setHasError,
    timerConfirmPhoneNumber,
    inputSmsCode,
    getSmsCode,
    checkRemainingSeconds,
    changeSmsCode,
  };
};

export default useConfirmPhoneNumber;
